import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import AccountAdminTableColumns from './accountAdminTableColumns';
import useCustomTable from '../../../../../hooks/common/useCustomTable';
import { useAuth } from '../../../../../hooks/common/useAuth';
import ReactTable from '../../../../../components/table/ReactTable';
import Button from '../../../../../components/Button';
import Pagination from '../../../../../components/table/ReactTablePagination';
import * as Styled from './AccountAdminTable.style';
import { AccountAdminListResponse, FilterOption, PaginationOption } from '../../common/types/AccountAdminFormType';
import { ADMIN_LEVEL_TYPE } from '../../common/constants';

interface IAccountAdminTable {
  accountAdminList: AccountAdminListResponse | undefined;
  onChangeFilterOption: (e: { value: string; id: keyof FilterOption }) => void;
  onChangePaginationOption: (id: keyof PaginationOption, value: number) => void;
  onClickSortOption: (columnId: string, isMultiSortable: boolean) => void;
  paginationOption: PaginationOption;
  sortOption: {
    sort: string;
  };
  handleClickResetFilter: () => void;
  currentPage: number;
  setCurrentPage: (page: number) => void;
}

const AccountAdminTable = (props: IAccountAdminTable): JSX.Element => {
  const {
    accountAdminList,
    onChangeFilterOption,
    onChangePaginationOption,
    paginationOption,
    onClickSortOption,
    sortOption,
    handleClickResetFilter,
    currentPage,
    setCurrentPage,
  } = props;

  const navigate = useNavigate();
  const columns = useMemo(() => AccountAdminTableColumns(onChangeFilterOption), [onChangeFilterOption]);
  const tableInstance = useCustomTable(columns, accountAdminList?.data);
  const { user } = useAuth();

  const isMasterAccount = user?.level === ADMIN_LEVEL_TYPE.MASTER;

  return (
    <>
      <Styled.CreateButtonWrapper>
        {isMasterAccount ? (
          <Button
            isRadius
            color="primary"
            text="관리자 생성"
            onClick={() => {
              navigate('/account/admin/create');
            }}
          />
        ) : null}
      </Styled.CreateButtonWrapper>
      <Styled.Container>
        <Styled.Header>
          <div className="total-cnt">
            <span className="cnt">{accountAdminList?.total || 0}</span>건이 조회되었습니다.
          </div>
          <Button isRadius color="primary" text="필터 초기화" onClick={handleClickResetFilter} />
        </Styled.Header>
        <Styled.Section>
          <ReactTable
            tableInstance={tableInstance}
            sortOtion={sortOption}
            onClickSortOption={onClickSortOption}
            isMultiSortable={false}
            emptyText="요청하신 검색 필터로 검색된 관리자 리스트가 없습니다."
          />
        </Styled.Section>
        <Pagination
          onChangePaginationOption={onChangePaginationOption}
          paginationOption={paginationOption}
          currentPage={currentPage}
          setCurrentPage={setCurrentPage}
          total={accountAdminList?.total || 0}
        />
      </Styled.Container>
    </>
  );
};

export default AccountAdminTable;
